export default __webpack_public_path__ + "static/media/share.4a856fc8.svg";